import React from 'react';

/*
  رمز الريال السعودي الجديد (هيئة النقد السعودي "ساما").
  مكوّن واحد يُستخدم بجانب كل سعر في الموقع، ويرث لون النص (currentColor)
  وحجمه من حجم الخط المحيط به تلقائياً.

  ملاحظة: هذا رسم SVG يمثّل الرمز. لو عندك ملف الرمز الرسمي (SVG)،
  استبدل محتوى الـ <svg> أدناه بمسار الرمز الرسمي فقط، وكل الموقع
  سيتحدّث تلقائياً لأنه يستخدم هذا المكوّن في كل مكان.
*/
export default function RiyalIcon({ size = '1em', style = {} }) {
  return (
    <svg
      viewBox="0 0 1124.14 1256.39"
      width={size}
      height={size}
      role="img"
      aria-label="ريال سعودي"
      style={{ display: 'inline-block', verticalAlign: '-0.125em', fill: 'currentColor', ...style }}
    >
      <path d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z" />
      <path d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.28-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-93.16,70.63-122.85,121.85v657.44l-135.2,28.74V0c-50.67,28.45-93.13,70.63-122.85,121.85v784.66l-330.68,70.33c-20.06,44.47-33.32,92.75-38.4,143.37l369.08-78.46v207.68c50.67-28.45,93.16-70.61,122.85-121.85v-112.15l135.2-28.74v135.2l-292.28,62.11h0c-20.06,44.47-33.32,92.75-38.4,143.37l330.68-70.33v135.2l-330.68,70.33h0c-20.06,44.47-33.32,92.75-38.4,143.37l369.08-78.46v-207.68l330.68-70.27Z" />
    </svg>
  );
}